import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { ClipboardCheck, ArrowRight, CheckCircle2 } from "lucide-react";

const GRAVITE = {
  generation: { label: "Bloque la génération du PDP", color: "#B3382C" },
  signature: { label: "Bloque la signature", color: "#E49B1A" },
  demarrage: { label: "Requis avant démarrage", color: "#E49B1A" },
  qualification: { label: "Complète la qualification", color: "#136B79" },
  recommande: { label: "Recommandé", color: "#5C6E70" },
};

export default function DossierIncomplet({ operationId, onGoto, refreshKey }) {
  const [data, setData] = useState(null);
  const load = useCallback(async () => {
    try { const r = await api.get(`/operations/${operationId}/dossier-incomplet`); setData(r.data); }
    catch (e) { /* silencieux */ }
  }, [operationId]);
  useEffect(() => { load(); }, [load, refreshKey]);
  if (!data) return null;

  if (data.complet) {
    return (
      <div className="card" data-testid="dossier-incomplet" style={{ borderLeft: "4px solid var(--vert, #2E7D5B)" }}>
        <h3 style={{ fontSize: "1rem", margin: 0, display: "flex", gap: 8, alignItems: "center" }}>
          <CheckCircle2 size={18} color="#2E7D5B" /> Dossier complet
        </h3>
        <p style={{ fontSize: ".84rem", color: "var(--text-muted)", marginTop: 6 }}>Aucun élément bloquant identifié à ce stade.</p>
      </div>
    );
  }

  const groups = {};
  for (const it of data.items) (groups[it.gravite] = groups[it.gravite] || []).push(it);
  const order = ["generation", "signature", "demarrage", "qualification", "recommande"];

  return (
    <div className="card" data-testid="dossier-incomplet" style={{ borderLeft: "4px solid #B3382C" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <ClipboardCheck size={18} color="#B3382C" />
        <h3 style={{ fontSize: "1rem", margin: 0 }}>Dossier incomplet</h3>
        <span className="tag" data-testid="dossier-total" style={{ background: "#B3382C", color: "#fff" }}>{data.total} point(s) à traiter</span>
      </div>

      {order.filter((g) => groups[g]).map((g) => (
        <div key={g} style={{ marginTop: 12 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
            <span style={{ width: 8, height: 8, borderRadius: 999, background: GRAVITE[g].color }} />
            <b style={{ fontSize: ".8rem", color: GRAVITE[g].color }}>{GRAVITE[g].label}</b>
          </div>
          {groups[g].map((it) => (
            <div key={it.code} data-testid={`dossier-item-${it.code}`} style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "7px 0", borderBottom: "1px solid var(--ligne, #eee)" }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: ".86rem", fontWeight: 600 }}>{it.libelle}</div>
                <div style={{ fontSize: ".76rem", color: "var(--text-muted)" }}>{it.detail}</div>
                <div style={{ fontSize: ".72rem", color: "var(--text-muted)", marginTop: 2 }}>
                  {it.domaine} · à corriger dans <b>{it.lien}</b> · rôle habilité : {it.roleHabilite}
                </div>
              </div>
              <button className="btn btn-g btn-sm" data-testid={`dossier-goto-${it.code}`} onClick={() => onGoto && onGoto(it.ongletIndex)} style={{ whiteSpace: "nowrap" }}>
                Corriger <ArrowRight size={13} />
              </button>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
